import jsPDF from "jspdf";

export default function imprimirCondes(item) {
  var doc = new jsPDF("landscape");
  doc.setProperties({
    title: "Liquidación de Caja",
  });

  let rows = [];
  let columnHeader = [
    "Fecha",
    "Paciente",
    "Obra Social",
    "Observaciones",
    "Forma de Pago",
    "Importe",
  ];
  let subtotales = {};
  item.cobrosIncluidos.forEach((element) => {
    var temp = [
      element.fechaString,
      element.paciente,
      element.obraSocial,
      element.observaciones,
      element.nombreFormaPago,
      element.totalString,
    ];
    rows.push(temp);
    if (element.idFormaPago === 1) {
      subtotales.efectivo = (subtotales.efectivo ?? 0) + element.total;
    } else {
      subtotales.transferencia =
        (subtotales.transferencia ?? 0) + element.total;
    }
    if (element.idFormaPago === 4) {
      subtotales.soloTransferencia =
        (subtotales.soloTransferencia ?? 0) + element.total;
    }
  });

  let nombreInstitucion = item.nombreInstitucion;

  let retenido = parseFloat(item.totalCobrado - item.totalPagado).toFixed(2);

  var nombreProf = item.esMultiple ? "VARIOS" : item.nomProfesional;
  doc.setFontSize(12);
  doc.text(nombreInstitucion, 13, 10);
  doc.setFontSize(16);
  doc.text("Liquidación de Caja", doc.internal.pageSize.getWidth() / 2, 20, {
    align: "center",
  });
  doc.line(123, 21, 174, 21);
  doc.setFontSize(12);
  doc.text("Profesional: " + nombreProf, 13, 30);
  doc.text("Fecha: " + item.fechaString, 13, 37);

  doc.autoTable(columnHeader, rows, {
    startY: 45,
    didParseCell: function (table) {
      if (table.section === "head") {
        table.cell.styles.fillColor = "#c4c5c5";
      }
    },
  });

  let finalY = doc.lastAutoTable.finalY;

  if (finalY > 180) {
    doc.addPage();
    finalY = 20;
  }

  doc.text(
    "Total percibido: $" +
      parseFloat(item.totalCobrado).toFixed(2).toString().replace(".", ","),
    280,
    finalY + 8,
    { align: "right" }
  );

  const subtotalTransferencia = isNaN(subtotales.soloTransferencia)
    ? 0
    : subtotales.soloTransferencia;
  const totalFinalLiquidacion = item.totalPagado - subtotalTransferencia;
  doc.text(
    "Total percibido transferencias: $" +
      parseFloat(subtotalTransferencia).toFixed(2).toString().replace(".", ","),
    280,
    finalY + 16,
    { align: "right" }
  );
  doc.text(
    "Saldo a percibir: $" +
      parseFloat(totalFinalLiquidacion).toFixed(2).toString().replace(".", ","),
    280,
    finalY + 24,
    { align: "right" }
  );

  window.open(doc.output("bloburl"), "_blank");
}
